//import dayjs from 'dayjs';

export function makeId(length) {
  let result = '';
  let characters = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';
  let charactersLength = characters.length;
  for ( let i = 0; i < length; i++ ) {
      result += characters.charAt(Math.floor(Math.random() * charactersLength));
  }
  return result;
}

export function getRandomInt(max = Number.MAX_SAFE_INTEGER) {
  return Math.floor(Math.random() * Math.floor(max));
}

export function getDateTimeString(timeString) {
  let time = new Date(timeString);
  let yyyy = time.getFullYear();
  let mm = (time.getMonth() + 1).toString().padStart(2, '0');
  let dd = time.getDate().toString().padStart(2, '0');
  let HH = time.getHours().toString().padStart(2, '0');
  let MM = time.getMinutes().toString().padStart(2, '0');
  let SS = time.getSeconds().toString().padStart(2, '0');
  return `${yyyy}-${mm}-${dd} ${HH}:${MM}:${SS}`;
}

export function getWhen(dateTime, includeTime = true) {
  if (dateTime === -Infinity) return "?";

  const date = dayjs(dateTime);
  if (!date) return "?";
  
  const now = dayjs();
  if (date.isSame(now, "day")) return includeTime ? `today (${date.format("HH:mm")})` : "today";
  if (date.isBefore(now)) {
    if (date.isSame(now.subtract(1, "day"),  "day")) return "yesterday";
    let diff = now.diff(date, "days");
    return `${diff} ${diff === 1 ? "day" : "days"} ago`;
  } else {
    if (date.isSame(now.add(1, "day"),  "day")) return "tomorrow";
    let diff = date.diff(now, "days");
    return `${diff} ${diff === 1 ? "day" : "days"} from now`;
  }
}

export function num2str(num, width) {
  if (!width) width = num.toString().length;
  return num.toString().padStart(width, '0');
}

export function numberWithDigitGrouping(x, symbol = " ") {
   return x?.toString().replace(/\B(?=(\d{3})+(?!\d))/g, symbol) || "";
}

export function toMetricPrefixed(number) {
  number = Number(number);
  if (!number) return "";

  const precision = 3;
  if (number / 1e3 < 1) return number.toPrecision(precision)/1;
  if (number / 1e6 < 1) return (number / 1e3).toPrecision(precision)/1 + "k";
  else return (number / 1e6).toPrecision(precision)/1 + "M";
}

export function toCSV(object, delimiter = ", ") {
  let result = "";

  let	keys = Object.keys(object).sort();
  for (let key of keys) {
    result += `${key}: ${object[key]}${delimiter}`;
  }

	return result.substring(0, result.length - delimiter.length);
}

export function weekFormatter(days) {
  if (days == null) return "?";
  return (Number(days) / 7).toFixed(1)/1 + "w";
}

export function getTrend(data, key, flagged) {
  return {
    data: data.map(row => ({ x: Number(row.RowKey), y: row[key] })),
    color: flagged ? "red" : "green"
  };
}

Array.prototype.last = function last() {
  if (this.length > 0) {
    return this[this.length - 1];
  }

  return null;
}